// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  ICreateMessageFromEstimationRequest,
  TCreateMessageFromEstimationModel,
  IMappers,
  TCreateMessageFromEstimationResponse,
  ICreateMessageFromEstimationResponseError,
} from './types';

export const defaultConfig: TCreateMessageFromEstimationModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'price-estimator',
  pathApi: '/v1/create-message-from-estimation/',
  requestType: 'json',
} as TCreateMessageFromEstimationModel;

export function createCreateMessageFromEstimationModel(
  parameters: ICreateMessageFromEstimationRequest,
): TCreateMessageFromEstimationModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ICreateMessageFromEstimationOptions<TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse400>;
  parameters: ICreateMessageFromEstimationRequest;
}

export async function fetchCreateMessageFromEstimation<TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ICreateMessageFromEstimationOptions<TResponse400>): Promise<TCreateMessageFromEstimationResponse | TResponse400> {
  const { statusCode, response, headers } = await httpApi.fetch(
    createCreateMessageFromEstimationModel(parameters),
    config,
  );
  if (mappers && statusCode in mappers) {
    if (statusCode === 400) {
      return mappers[400](response as ICreateMessageFromEstimationResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TCreateMessageFromEstimationResponse;
}
